module.exports = __webpack_public_path__ + "static/img/askZhet.cc87e59e.png";